import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useFormik } from 'formik';

import {
  initialValues,
  validationSchema,
} from '../../../../../forms/transactionForm';
import TransactionPresenter from '../../../../../presenters/TransactionPresenter';
import CashbackPresenter from '../../../../../presenters/CashbackPresenter';
import StorePresenter from '../../../../../presenters/StorePresenter';
import Modal from '../../../../../components/Modal';
import Button from '../../../../../components/Button';
import Row from '../../../../../components/Row';

import EditTransactionForm from './components/EditTransactionForm';

const EditTransactionModal = (props) => {
  const {
    transactions,
    cashback,
    stores,
    isOpen,
    onClose,
    onTransactionUpdate,
  } = props;
  const [index, setIndex] = useState(0);
  const [transaction, setTransaction] = useState();
  const [storesField, setStoreField] = useState([]);

  useEffect(() => {
    setTransaction({
      ...transactions[index],
      store_id: storesField[index]?.storeId,
    });
    setValues(
      initialValues({
        ...transactions[index],
        ...storesField[index],
      })
    );
  }, [index, transactions]);

  const formik = useFormik({
    initialValues: initialValues(transactions[index]),
    onSubmit: (values) => handleUpdate(values),
    enableReinitialize: true,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema,
  });

  const { handleSubmit, setFieldValue, values, errors, setValues } = formik;

  const handleChange = ({ target }) => {
    const { id, value } = target;
    setFieldValue(id, value);
    const array = [...storesField];
    array[index] = { ...storesField[index], [id]: value };
    setStoreField(array);
  };

  const handleNext = () => {
    setIndex(index + 1);
  };

  const handleBack = () => {
    setIndex(index - 1);
  };

  const handleUpdate = (values) => {
    const isLast = index + 1 === transactions.length ? true : false;
    onTransactionUpdate(values, transactions[index], isLast);

    if (!isLast) {
      handleNext();
    }
    if (isLast) {
      setIndex(0);
    }
  };

  return (
    <Modal
      title="Edit Transaction"
      onClose={() => {
        onClose();
        setIndex(0);
      }}
      isModalOpen={isOpen}
    >
      <Row>
        <p className="blackText">
          {`${TransactionPresenter.date(
            transaction
          )} - ${TransactionPresenter.name(
            transaction
          )} - ${TransactionPresenter.amountReadable(transaction)}`}
        </p>
        <p className="blueText">
          {`(${index + 1} OF ${transactions.length} SELECTED)`}
        </p>
      </Row>
      <form onSubmit={handleSubmit}>
        <EditTransactionForm
          values={values}
          onChange={handleChange}
          stores={stores}
          cashback={cashback}
          errors={errors}
          transaction={transaction}
        />
        <div className="modal-actions-right">
          <Button
            className="modal-button"
            onClick={handleBack}
            disabled={index == 0}
          >
            Previous
          </Button>
          <Button
            className="modal-button"
            onClick={handleNext}
            disabled={index + 1 === transactions.length}
          >
            Next
          </Button>
        </div>
        <div className="modal-actions-right">
          <Button
            className="modal-button-red"
            type="submit"
            onClick={handleSubmit}
          >
            Save Changes
          </Button>
        </div>
      </form>
    </Modal>
  );
};

EditTransactionModal.propTypes = {
  transactions: PropTypes.arrayOf(TransactionPresenter.shape().isRequired),
  isOpen: PropTypes.bool.isRequired,
  onTransactionUpdate: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  cashback: CashbackPresenter.shape({}),
  stores: PropTypes.arrayOf(StorePresenter.shape()),
};

EditTransactionModal.defaultProps = {
  cashback: null,
  stores: [],
};

export default EditTransactionModal;
